<template>
  <span
    class="ca-status-tag gap-size-2 px-size-3 py-size-2 rounded-circle caption-medium"
  >
    <slot>{{ label }}</slot>
  </span>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: "Novo",
  },
});
</script>

<style scoped lang="scss">
.ca-status-tag {
  display: inline-flex;
  align-items: center;
  background:
    linear-gradient(
      0deg,
      var(--ca-color-feedback-warning-light) 0%,
      var(--ca-color-feedback-warning-light) 100%
    ),
    var(--ca-color-text-inverted);
  color: var(--ca-color-text-body);
  white-space: nowrap;
}
</style>
